import { useState } from "react";
import { useNavigate } from "react-router-dom";
import MobileTailwind from "./MobileTailwind";
import PrimaryButton from "./components/PrimaryButton";
import SubHeader from "./components/SubHeader";

const EmailReceipt = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [whatsapp, setWhatsapp] = useState("");

  const handleSend = () => {
    navigate("/mobile/email-sent");
  };

  return (
    <>
      <MobileTailwind />
      <div id="mobile-root" className="min-h-screen w-full bg-black flex justify-center">
        <div className="relative w-full min-h-screen overflow-hidden flex flex-col" style={{ backgroundColor: "#F4F4F5" }} >
          {/* Header */}
          <SubHeader title="Email Receipt" />

          {/* Body */}
          <div className="flex-1 px-4 pt-4 pb-[120px] flex flex-col gap-4">
            <div className="flex flex-col gap-1">
              <p className="font-opensans text-[16px] text-[rgba(17,17,17,0.8)]">
                Please enter your email to send the receipt
              </p>
            </div>

            <div className="flex flex-col gap-2">
              <label className="font-opensans text-[14px] text-[#111]">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter email address"
                className="w-full h-[47px] rounded-[6px] border bg-white px-4 font-opensans text-[14px] text-[#111] outline-none placeholder:text-[#8F9098]"
                style={{ borderColor: "#C5C6CC" }}
              />
            </div>

            <div className="flex flex-col gap-2">
              <label className="font-opensans text-[14px] text-[#111]">
                WhatsApp Number
              </label>
              <input
                type="tel"
                value={whatsapp}
                onChange={(e) => setWhatsapp(e.target.value.replace(/\D/g, ""))}
                placeholder="Enter number"
                inputMode="numeric"
                className="w-full h-[47px] rounded-[6px] border bg-white px-4 font-opensans text-[14px] text-[#111] outline-none placeholder:text-[#8F9098]"
                style={{ borderColor: "#C5C6CC" }}
              />
            </div>
          </div>

          {/* Sticky bottom CTA */}
          <div className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full bg-white px-4 py-4 z-50 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]">
            <PrimaryButton onClick={handleSend}>
              Send
            </PrimaryButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmailReceipt;
